(function(){
  document.querySelectorAll('.carr').forEach(function(sec){
    var row = sec.querySelector('.carr-row');
    if (!row) return;
    [].forEach.call(sec.querySelectorAll('.carr-flechas button'), function(b){
      b.addEventListener('click', function(){
        var d = b.getAttribute('data-dir') === 'izq' ? -1 : 1;
        row.scrollBy({left: d * row.clientWidth * 0.8, behavior: 'smooth'});
      });
    });
  });
})();
